import { Module } from 'vuex';
import api from '@/services/publicApi';

export interface RuntimeState {
  enabledModules: string[];
  forfaitMaxShops: number;
  maintenanceEnabled: boolean;
  paymentDemoEnabled: boolean;
  loaded: boolean;
  loading: boolean;
  error: string | null;
}

let loadingPromise: Promise<void> | null = null;

const runtime: Module<RuntimeState, Record<string, unknown>> = {
  namespaced: true,
  state: (): RuntimeState => ({
    enabledModules: [],
    forfaitMaxShops: 5,
    maintenanceEnabled: false,
    paymentDemoEnabled: false,
    loaded: false,
    loading: false,
    error: null,
  }),
  getters: {
    moduleEnabled: (state) => (key: string): boolean => ['dashboard', 'shops', 'users', 'settings', 'notifications'].includes(key) || state.enabledModules.includes(key),
    forfaitMaxShops: (state) => state.forfaitMaxShops,
    paymentDemoEnabled: (state) => state.loaded && state.paymentDemoEnabled,
    isLoading: (state) => state.loading,
    loadError: (state) => state.error,
    isLoaded: (state) => state.loaded,
  },
  mutations: {
    SET(state, payload) {
      state.enabledModules = payload.enabled_modules || [];
      state.forfaitMaxShops = payload.forfait_max_shops || 5;
      state.maintenanceEnabled = Boolean(payload.maintenance_enabled);
      state.paymentDemoEnabled = payload.payment_demo_enabled === true;
      state.loaded = true;
    },
    SET_LOADING(state, loading: boolean) {
      state.loading = loading;
    },
    SET_ERROR(state, error: string | null) {
      state.error = error;
      if (error) {
        state.paymentDemoEnabled = false;
      }
    },
  },
  actions: {
    load({ commit, state }, options: { force?: boolean } = {}): Promise<void> {
      if (state.loaded && !options.force) {
        return Promise.resolve();
      }

      if (loadingPromise) {
        return loadingPromise;
      }

      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      loadingPromise = api.get('/public/runtime-config')
        .then((response) => {
          commit('SET', response.data.data || {});
        })
        .catch((error) => {
          commit('SET_ERROR', 'La configuration de l’application est indisponible.');
          throw error;
        })
        .finally(() => {
          commit('SET_LOADING', false);
          loadingPromise = null;
        });

      return loadingPromise;
    },
  },
};

export default runtime;
